<div class="kt-grid kt-grid--hor kt-grid--root kt-login kt-login--v1" id="kt_login">
	<div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--desktop kt-grid--ver-desktop kt-grid--hor-tablet-and-mobile">
		<!--begin::Aside-->
		<div class="kt-grid__item kt-grid__item--order-tablet-and-mobile-2 kt-grid kt-grid--hor kt-login__aside" style="background-image: url(./assets/media//bg/bg-4.jpg);">
			<div class="row">
				<div class="col-md-6">

					<div class="kt-grid__item">
						<a href="javascript:;" class="kt-login__logo">
							<img src="./assets/media/logos/cat_300.png" alt="">
						</a>
					</div>
				</div>
				<div class="col-md-6">
					<div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver">
						<div class="kt-grid__item kt-grid__item--middle">
							<h3 class="kt-login__title">SPLoto.Net</h3>
							<h4 class="kt-login__subtitle">Versão  {{version}}</h4>
						</div>
					</div>

				</div>

				<div class="col-md-12">
					<span class="instructions">
						Seja bem vindo ao SPLoto.Net !!!
					
						<br>
						<br>O primeiro software para loteria com processamento on line  em tempo real
						<br>
						<br>Pode ser utilizado em computadores pessoais, tablets, celulares, independentemente do sistema operacional (Windows,MAc,
						Linux, etc).
						<br>
						<br>Pode ser utilizado com servidor em nuvem, ou processamento na maquina local do cliente.
						<br>Ao contrário de outras ferramentas, que fazem somente operações básicas online, o SPLoto.Net  é capaz de fazer tudo o
						que uma aplicação desktop faz. Combinações, desdobramentos, filtragem, conferência, impressão, etc.
					<br>
						<br> Muito obrigado e boa sorte!!!
						<br> Equipe Spolti Technologies
					</span>

				</div>
			</div>


			<!-- <div class="kt-grid__item">
				<div class="kt-login__info">
					<div class="kt-login__copyright">
						© {{today|date:'yyyy'}} Metronic
					</div>
					<div class="kt-login__menu">
						<a href="javascript:;" class="kt-link">Privacy</a>
						<a href="javascript:;" class="kt-link">Legal</a>
						<a href="javascript:;" class="kt-link">Contact</a>
					</div>
				</div>
			</div> -->
		</div>
		<!--begin::Aside-->

		<!--begin::Content-->
		<div class="kt-grid__item kt-grid__item--fluid  kt-grid__item--order-tablet-and-mobile-1 kt-login__wrapper">
			<router-outlet></router-outlet>
		</div>
		<!--end::Content-->
	</div>
</div>